import React from "react";
import MainContainer from "pages/_components/MainContainer";
import { ResponsiveHeader } from "pages/_components/header";
import { useSelector } from "react-redux";
import Notification from "pages/_components/Notification";
import GeneralCredentialForm from "pages/_components/Forms/GeneralCredentialForm";
import I18n from "pages/_components/I18n";
import { useConfirmTransaction } from "hooks/useConfirmTransaction";
import { actions as creditBillsActions } from "reducers/creditBills";
import { bool } from "prop-types";
import CreditBillsSummaryBody from "./components/Summary";

const CreditBillsSummaryPage = ({ isDesktop }) => {
    const { actionData, actionTicket } = useSelector((state) => state.creditBills);
    useConfirmTransaction(actionData, actionTicket, "creditBills/inform-cbu");
    return (
        <>
            <Notification scopeToShow="credit.bills.modify.page" />
            <ResponsiveHeader id="credit.bills.modify.cbu.title" />
            <MainContainer>
                <div className="container">
                    <I18n id="credit.bills.summary.confirm" />
                    <CreditBillsSummaryBody
                        cbu={actionData.cbu}
                        invoiceList={actionData.invoiceList}
                        isDesktop={isDesktop}
                    />
                    <GeneralCredentialForm
                        transactionData={actionData}
                        action={creditBillsActions.transmitBill}
                        idActivity="fcem.action"
                        hideIndications
                        isToken
                    />
                </div>
            </MainContainer>
        </>
    );
};

CreditBillsSummaryPage.propTypes = {
    isDesktop: bool.isRequired,
};

export default CreditBillsSummaryPage;
